<div class="modal-header border-0 pb-0">
  <div class="d-flex align-items-center w-100">
    <i class="fas fa-times-circle pjud-unavailable-modal__icon mr-3" aria-hidden="true"></i>
    <h4 class="modal-title mb-0"><strong>{{ title }}</strong></h4>
  </div>
</div>
<div class="modal-body pt-3">
  <p class="pjud-unavailable-modal__message mb-0">{{ message }}</p>
  <div class="pjud-unavailable-modal__contact mt-4">
    <span class="pjud-unavailable-modal__contact-label">Correo de soporte:</span>
    <div class="d-flex align-items-center flex-wrap mt-1">
      @if (loadingEmail) {
        <span class="text-muted">Cargando...</span>
      } @else {
        <a class="pjud-unavailable-modal__email" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
        <button
          type="button"
          class="btn btn-link btn-sm pjud-unavailable-modal__copy-btn ml-2"
          (click)="copyEmail()"
          title="Copiar correo"
          aria-label="Copiar correo de soporte">
          <i class="far fa-copy"></i>
        </button>
        @if (copied) {
          <span class="pjud-unavailable-modal__copied ml-2">
            <i class="fas fa-check mr-1" aria-hidden="true"></i>Copiada
          </span>
        }
      }
    </div>
  </div>
</div>
<div class="modal-footer border-0 pt-0">
  <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">
    Aceptar
  </button>
</div>
